// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"636":"8788e23f94c41046","668":"e6a6d0634400a066","1295":"1b1ce9ef96210c54","9161":"79e0b7b84b4e00f7"}[chunkId] + ".css";
};